import { useEffect, useRef } from 'react';

/**
 * Adds an `is-visible` class to the element once it scrolls into view.
 * Pair with the `.reveal` / `.reveal-stagger` utility classes in index.css.
 */
export default function useReveal(options = { threshold: 0.18 }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      options
    );

    observer.observe(el);
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return ref;
}
